// extracted by mini-css-extract-plugin
module.exports =  {"button":"ScoringButton-Zij2__button","red":"ScoringButton-xrCL__red","orange":"ScoringButton-CEmq__orange","green":"ScoringButton-_8YT__green"};